<template>
    <div :style="{'margin-top':marginTop,'height':height,'width':width}"></div>
</template>

<script>
    export default {
        name: "DocGutter",
        props: {
            marginTop: {
                default: "0px"
            },
            height: {
                default: "0px"
            },
            width: {
                default: "0px"
            }
        }
    }
</script>